import { put, call, takeLatest, select } from 'redux-saga/effects';
import { Types, Creators } from './carousel-items-duck.js';
import { toast } from 'react-toastify';
import * as Api from './carousel-items-api.js';
import { Creators as GlobalCreators } from '../globals/globals-duck.js';
import toastApiError from 'utils/api-error.js';

export const getState = (state) => state.CarouselItem;

export function* fetchAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const response = yield call(Api.getCarouselItems);
    yield put(Creators.carouselItemsFetched(response.data));
  } catch (error) {
    toastApiError(error);
    console.log(error);
  } finally {
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* createAsync({ data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.carouselItemsCreate, data);
    toast.success('Item criado com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* updateAsync({ data }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const { id, ...rest } = data;
    yield call(Api.carouselItemsUpdate, id, rest);
    toast.success('Item atualizado com sucesso!');
    yield put(Creators.carouselItemsCloseModal());
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* deleteAsync({ id }) {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    yield call(Api.carouselItemsDelete, id);
    toast.success('Item removido com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export function* updateOrdersAsync() {
  try {
    yield put(GlobalCreators.globalsSetLoading(true));
    const state = yield select(getState);
    yield call(Api.carouselItemsUpdateOrders, { items: state.carouselItemsToUpdateOrder });
    toast.success('Ordem atualizada com sucesso!');
  } catch (error) {
    toastApiError(error);
  } finally {
    yield fetchAsync();
    yield put(GlobalCreators.globalsSetLoading(false));
  }
}

export default [
  takeLatest(Types.CAROUSEL_ITEMS_FETCH_ASYNC, fetchAsync),
  takeLatest(Types.CAROUSEL_ITEMS_CREATE_ASYNC, createAsync),
  takeLatest(Types.CAROUSEL_ITEMS_UPDATE_ASYNC, updateAsync),
  takeLatest(Types.CAROUSEL_ITEMS_DELETE_ASYNC, deleteAsync),
  takeLatest(Types.CAROUSEL_ITEMS_UPDATE_ORDERS_ASYNC, updateOrdersAsync),
];
